/*jshint scripturl:true*/

window.Rayban = window.Rayban || {}

function clearSessionStorage() {
    var storeIdValue = $("#storeId").val();
    var langIdValue = $("#langId").val();
    sessionStorage.removeItem("rayban." + storeIdValue + "." + langIdValue + ".sidebar_refreshLS");
    sessionStorage.removeItem("rayban." + storeIdValue + "." + langIdValue + ".headerprofile_refreshLS");
    count = [0, 0];
}

function replaceDomElement(elementSelector, newContent) {
    var isSessionExpired = $('#isSessionExpired').val();
    if (isSessionExpired != 'true') {
        var $currentElement = $(elementSelector);
        var $newContent = $(newContent);
        $newContent.each(function() {
            var $newElement = $(this);
            if ($newElement.is(elementSelector)) {
                //case: the element that we actually intended to replace
                $currentElement.replaceWith($newElement);
            } else if (typeof $newElement.attr('id') !== 'undefined') {
                //case: any other element eventually contained in newContent and already available in page
                //(i.e. siblings of elementSelector inside newContent, e.g hidden inputs)
                $('#' + $newElement.attr('id')).replaceWith($newElement);
            } else {
                //case: any other element eventually contained in newContent and not identified in page
                $currentElement.after($newElement);
            }
        });
    }
}

function headerFunctions() {
    //var header_loginLS, sidebar_refreshLS, headerprofile_refreshLS;
    var count = [0, 0];
    var storeIdValue = $("#storeId").val();
    var langIdValue = $("#langId").val();
    var catalogIdValue = $("#catalogId").val();

    /*window.wcs_headerlogin_refresh = function(storeid, catalogid, langid, userid, userType) {
        count[0]++;
        $.ajax({
            type: "GET",
            url: 'DMPHeaderLoginView?catalogId=' + catalogid + '&langId=' + langid + '&storeId=' + storeid + '&userId=' + userid + '&userType=' + userType,
            success: function(data) {
                Rayban.storage.save("rayban." + storeIdValue + "." + langIdValue + ".header_loginLS", data, "stringify");
                replaceDomElement('.wcs-utility-nav', data);
                var $wcsUserId = $('#wcsUserId');
                var $wcsUserType = $('#wcsUserType');
                if ($wcsUserId.attr('id') !== undefined) {
                    userid = $wcsUserId.val();
                }
                if ($wcsUserType.attr('id') !== undefined) {
                    userType = $wcsUserType.val();
                }
                //if (Rayban.storage.fetch("rayban." + storeIdValue + "." + langIdValue + ".headerprofile_refreshLS") === null || count[0] === 1) {
                    //wcs_headerprofile_refresh(storeid, catalogid, langid, userid, userType);
                //}
                $.publish('SITE_MAIN_HEADERLOGIN_REFRESH_DONE');
            }
        });
    };*/

    /*window.wcs_sidebar_refresh = function(storeid, catalogid, langid, userid) {
        $.ajax({
            type: "GET",
            url: 'SideBarView?catalogId=' + catalogid + '&langId=' + langid + '&storeId=' + storeid + '&userId=' + userid,
            success: function(data) {
                sessionStorage.setItem("rayban." + storeIdValue + "." + langIdValue + ".sidebar_refreshLS", data);

                var sidebarSelector = $('#wcs-sidebar-panel').size() > 0 ? '#wcs-sidebar-panel' : '.wcs-panel-container';
                replaceDomElement(sidebarSelector, data);
                sidebarHideFavEmptyDiv();
                selected_country_value();
                sliderRightMenu();
                dropscroller_hover_fn();
                openLinksInNewTab();
                wcs_paypal_overlay();
                shoprunnerUpdateContent();
                $('.wcs-shopping-cart > .wcs-minicart-prod').last().addClass('last');
                setTimeout(function() {
                    if (typeof showAccessoryComptMessage === 'function') {
                        showAccessoryComptMessage();
                    }
                }, 100);
                if ("ProductPage" === $("input[name='pageName']").val()) {
                    if ($("#isRoxEnabled").val() === "true") {
                        if (typeof pdpRoxInst === "undefined") {
                            $.publish('SITE_MAIN_CHECK_WISHLIST_ADD',{ bool: 'FALSE' });
                        } else {
                            pdpRoxInst.checkifAddedToWishList("FALSE");
                        }
                    } else if (typeof pdpObj === "undefined") {
                        $.publish('SITE_MAIN_CHECK_WISHLIST_ADD',{ bool: 'FALSE' });
                    } else if (null !== pdpObj) {
                        if (pdpObj.selectedProductData !== null) {
                            pdpObj.checkifAddedToWishList("FALSE");
                        } else if (chinaPdpObj.selectedProductData !== null) {
                            chinaPdpObj.checkifAddedToWishList("FALSE");
                        }
                    }
                }
                $.publish('SITE_MAIN_SIDEBAR_REFRESH_DONE');
            }
        });
    };*/

    /*window.wcs_headerprofile_refresh = function(storeid, catalogid, langid, userid, userType) {
        count[1]++;
        $.ajax({
            type: "GET",
            url: 'DMPHeaderProfileView?storeId=' + storeid + '&userId=' + userid + '&userType=' + userType + '&catalogId=' + catalogid + '&langId=' + langid,
            success: function(data) {
                sessionStorage.setItem("rayban." + storeIdValue + "." + langIdValue + ".headerprofile_refreshLS", data);
                if (sessionStorage.getItem("rayban." + storeIdValue + "." + langIdValue + ".sidebar_refreshLS") === null || count[1] === 1) {
                    //wcs_sidebar_refresh(storeid, catalogid, langid, userid);
                    $("#wcs-cart-container").find(".wcs-shopping-cart .remove-product span").on("click", function() {
                        clearSessionStorage();
                    });
                }
                $.publish('SITE_MAIN_HEADERPROFILE_REFRESH_DONE');
            }
        });
    };*/

    window.csr_header_refresh = function() {

        var userStatus = getCookie('rbuser_status');
        $('body').prepend('<div id="csrHeaderFrame" style="padding: 42px 0px 43px; text-align: center;">Csr loading...</div>');
        // var storeCSRId = $('input[name=storeId]').val() || storeid;
        var storeCSRId = wcs_config.storeId;

        $.ajax({
            url: 'CSRAjaxHeader?AjaxHeader=TRUE&storeId='+ storeCSRId,
            type: "post",
            dataType: "html",
            success: function(response) {
                var $csrHeaderFrame = $('#csrHeaderFrame');
                var $storeSelection = $('#storeSelection');
                $csrHeaderFrame.removeAttr('style').empty().append(response);
                $csrHeaderFrame.find('header div').removeClass('wcs-hide');
                var value = $storeSelection.find('option:selected').text();

                if (userStatus === 'G' || userStatus === 'R') {
                    $storeSelection.prop('disabled', true).next().html(value);
                    $csrHeaderFrame.find('.csr-gray-link').attr('href','#').css('text-decoration','none');
                } else {
                    $storeSelection.next().html(value);
                    $storeSelection.on('change', function() {
                        var $SwitchStoreForm = $('#SwitchStoreForm');
                        var selectedVal = $storeSelection.find('option:selected').text();
                        $storeSelection.next().html(selectedVal);
                        $SwitchStoreForm.find('#reloadURL').val(document.location.href);
                        $SwitchStoreForm.find('#storeSelectionHidden').val($storeSelection.val());
                        $SwitchStoreForm.submit();
                    });
                    $(document).on('click','.d-pdp-prod-addtocart', function() {
                        csr_addtobag_header_refresh();
                    });
                }
            }
        });
    };

    window.csr_addtobag_header_refresh = function() {
        var $csrHeaderFrame = $('#csrHeaderFrame');
        $csrHeaderFrame.empty().css({'padding': '42px 0 43px', 'text-align': 'center'}).html('Csr loading...');
        $.ajax({
            url: 'CSRAjaxHeader?AjaxHeader=TRUE&storeId='+$('input[name=storeId]').val()+ '&fromPage=PDP',
            type: "post",
            dataType: "html",
            success: function(response) {
                $csrHeaderFrame.removeAttr('style').empty().append(response);
                $csrHeaderFrame.find('header div').removeClass('wcs-hide');
                var $storeSelection = $('#storeSelection');
                var value = $storeSelection.find('option:selected').text();
                $storeSelection.prop('disabled', true).next().html(value);
                $csrHeaderFrame.find('.csr-gray-link').attr('href','#');
            }
        });
    };

    var tmpuserstatuscookie = getCookie('rbuser_status');
    tmpuserstatuscookie = tmpuserstatuscookie ? tmpuserstatuscookie.toLowerCase() : '';

    var tmpheaderlogin = sessionStorage.getItem("rayban." + storeIdValue + "." + langIdValue + ".header_loginLS");
    var tmpheaderuserid = "";
    var tmpuserstatuspage = "";
    if (tmpheaderlogin != undefined && tmpheaderlogin != "") {
        tmpheaderlogin = tmpheaderlogin.toLowerCase();
        tmpheaderuserid = tmpheaderlogin;
        tmpheaderlogin = tmpheaderlogin.substring(tmpheaderlogin.indexOf('name="wcsusertype"'));
        tmpheaderuserid = tmpheaderuserid.substring(tmpheaderuserid.indexOf('name="wcsuserid"'));
        if (tmpheaderlogin != "") {
            tmpheaderlogin = tmpheaderlogin.substring(tmpheaderlogin.indexOf('value="'));
            tmpuserstatuspage = tmpheaderlogin.substring(7,8);
            tmpheaderuserid = tmpheaderuserid.substring(tmpheaderuserid.indexOf('value="'));
            tmpheaderuserid = tmpheaderuserid.substring(7);
            tmpheaderuserid = tmpheaderuserid.substring(0,tmpheaderuserid.indexOf('"'));
            if (tmpuserstatuscookie != tmpuserstatuspage && tmpuserstatuscookie != "") {
                sessionStorage.removeItem("rayban." + storeIdValue + "." + langIdValue + ".header_loginLS");
                clearSessionStorage();
            } else if (tmpuserstatuscookie == tmpuserstatuspage && tmpuserstatuscookie == "r") {
                var tmpcurrentuserid = getCookie('utagdata_override_user_id');
                if (tmpheaderuserid != tmpcurrentuserid && tmpcurrentuserid != '') {
                    sessionStorage.removeItem("rayban." + storeIdValue + "." + langIdValue + ".header_loginLS");
                    clearSessionStorage();
                }
            } else if (tmpuserstatuscookie == tmpuserstatuspage && tmpuserstatuscookie == "g") {
                var tmpcookieuserid = getCookie('WC_USERACTIVITY_'+tmpheaderuserid);
                if (tmpcookieuserid == undefined || tmpcookieuserid == "") {
                    sessionStorage.removeItem("rayban." + storeIdValue + "." + langIdValue + ".header_loginLS");
                    clearSessionStorage();
                }
            }
        }
    }

    $(".wcs-addtobag").on("click", function() {
        clearSessionStorage();
    });

    $(".remove-product span").on("click", function() {
        $(".wcs-right-panel .wcs-cost-innerContainer a").attr("href", "javascript:void(0);");
        clearSessionStorage();
    });

    $(".wcs-pdp-title-wrapper .wcs-save").on("click", function() {
        clearSessionStorage();
    });

    $("#login_submit").on("click", function() {
        clearSessionStorage();
        sessionStorage.removeItem("rayban." + storeIdValue + "." + langIdValue + ".header_loginLS");
    });

    $("#HeaderDN_Logout").off("click").on("click", function (e) {
        clearSessionStorage();
        if (document.cookie.indexOf("xvtouser")!==-1) {
            document.cookie = 'xvtouser' + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
        }
        sessionStorage.removeItem("rayban." + storeIdValue + "." + langIdValue + ".header_loginLS");
        $.cookie('activePanel','0', { path: '/' });
        if (getCookie('EyeMedLogin') !== undefined) {
            document.cookie = 'EyeMedLogin' + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
    });

    var $wcsBasketMarginTop = $('.wcs-basketMarginTop');

    $wcsBasketMarginTop.find(".wcs-shopping-item-qtyPlus").on("click", function() {
        clearSessionStorage();
    });

    $wcsBasketMarginTop.find(".wcs-shopping-item-qtyMinus.wcs-on").on("click", function() {
        clearSessionStorage();
    });

    $("#wcs-cart-container").find(".wcs-shopping-cart .remove-product span").off("click").on("click", function() {
        $(".wcs-right-panel .wcs-cost-innerContainer a").attr("href", "javascript:void(0);");
        clearSessionStorage();
    });

    $("#wcs-star-container .wcs-shortlist-tray .wcs-remove-star-pd").off("click").on("click", function() {
        clearSessionStorage();
    });

    $(".wcs-wrapper-standard-modified-table .wcs-shopping-item-remove").off("click").on("click", function() {
        $(this).trigger('removeBagItemEvent');
        clearSessionStorage();
    });

    $(".wcs-shortlist-tray a.wcs-addtobag").off("click").on("click", function() {
        clearSessionStorage();
    });

    $('#user_register_form').find("#createAccount").off("click").on("click", function() {
        clearSessionStorage();
        sessionStorage.removeItem("rayban." + storeIdValue + "." + langIdValue + ".header_loginLS");
    });

    $('.wcs-shipping-bar').off("click.wcs").on("click.wcs", '.wcs-utility-nav .wcs-login-link', function(e) {
        $('.wcs-myacc-login').slideToggle("normal");
        $(this).toggleClass('wcs-open');
    });

    $('.wcs-hd-menu').off("click.wcs").on("click.wcs", '.wcs-utility-nav .wcs-login-link', function (e) {
        $('.wcs-myacc-login').slideToggle("normal");
        $(this).toggleClass('wcs-open');
    });

    var order_confirm = window.location.href;
    var order_success = order_confirm.split("?");
    if (order_success[0].indexOf("OrderOKView") != -1) {
        clearSessionStorage();

        /* Local Storage population for Credit card details form - START */
        clearCreditCardDetailsFromLocalStorage();
        /* Local Storage population for Credit card details form - END */
    }

    function setCookie(cname,cvalue,exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires=" + d.toGMTString();
        document.cookie = cname+"="+cvalue+"; "+expires;
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i=0; i<ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1);
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    //If the protocols of the pages (previous and current) are the same, AJAX call need not be made. Local Storage data is used.
    function makeAJAXCall() {
        var prev_page_protocol = getCookie("prev_protocol");

        //If local storage for header login exists, replace with local storage data.
        var sessionStorage_headerLoginLS = sessionStorage.getItem("rayban." + storeIdValue + "." + langIdValue + ".header_loginLS");
        var userTypeValue = $("#userType").val();
        var $wcsUserId = $('#wcsUserId');
        var wcsUserIdValue = $wcsUserId.val();
        if ($("#wcs-page").length && sessionStorage_headerLoginLS) {
            replaceDomElement('.wcs-utility-nav', sessionStorage_headerLoginLS);

            //if (sessionStorage.getItem("rayban." + storeIdValue + "." + langIdValue + ".headerprofile_refreshLS") === null || count[0] === 1) {
                //wcs_headerprofile_refresh(storeIdValue, catalogIdValue, langIdValue, wcsUserIdValue, userTypeValue);
            //} else
            //  if (sessionStorage.getItem("rayban." + storeIdValue + "." + langIdValue + ".sidebar_refreshLS") === null || count[0] === 1) {
            //    /*wcs_sidebar_refresh(storeIdValue, catalogIdValue, langIdValue, wcsUserIdValue);*/
            //} else {
                var sidebarSelector = $('#wcs-sidebar-panel').size() > 0 ? '#wcs-sidebar-panel' : '.wcs-panel-container';
                var sessionsStorage_sidebar = sessionStorage.getItem("rayban." + storeIdValue + "." + langIdValue + ".sidebar_refreshLS");
                replaceDomElement(sidebarSelector, sessionsStorage_sidebar);

                $("#wcs-cart-container").find(".wcs-shopping-cart .remove-product span").on("click", function() {
                    clearSessionStorage();
                });
                sidebarHideFavEmptyDiv();
                selected_country_value();
                sliderRightMenu();
                dropscroller_hover_fn();
                openLinksInNewTab();
                shoprunnerUpdateContent();
                !$('.rb-plp-page').length && $.publish('SITE_MAIN_CHECK_WISHLIST_ADD');
            //}
        }
        //else {
        //    wcs_headerlogin_refresh(storeIdValue, catalogIdValue, langIdValue, wcsUserIdValue, userTypeValue);
        //}

        current_page_protocol = location.protocol;
        //RB-7185
        //if (current_page_protocol !== prev_page_protocol) {
        //    wcs_headerlogin_refresh(storeIdValue, catalogIdValue, langIdValue, wcsUserIdValue, userTypeValue);
        //}

        if (prev_page_protocol !== "" || prev_page_protocol !== null) {
            setCookie("prev_protocol", current_page_protocol, 365);
        }
    }

    if ($("#wcs-page").length) {
        var pageTemplate = $("#pgTemplate").val();
        if (pageTemplate !== "DeliveryPage" && pageTemplate !== "PaymentPage" && pageTemplate !== "PasswordReset") {
            makeAJAXCall();
        }
    }

    if (getCookie('isCSRSession')) {
        $('.wcs-header .wcs-drop_panel.wcs-top106').addClass('inCsrView');
        csr_header_refresh();
    }

    /***Show eyemed header bar, if the user has already logged in to eyemed***/
    if (getCookie('EyeMedLogin') && getCookie('EyeMedLogin') === "true") {
        $('.eyemed-global-login-bar').removeClass('wcs-hide');
    }

    /***Show eyemed header bar, if the user has already logged in to eyemed***/
    /****RB-17555, hover over menus when eymed logged in****/
    $(".wcs-hd-container .wcs-hd-menu .wcs-primary a").off("hover").on("hover", function() {
        var $wcsFadeoutTop106 = $(".wcs-fadeout.wcs-top106");
        var isExistCsrHeaderFrame = $("#csrHeaderFrame").length;
        if (getCookie('EyeMedLogin') && getCookie('EyeMedLogin') === "true") {
            if (isExistCsrHeaderFrame) {
                $wcsFadeoutTop106.addClass("wcs-top248").removeClass("wcs-top106");
            } else {
                $wcsFadeoutTop106.addClass("wcs-top133");
            }
        } else {
            if (isExistCsrHeaderFrame) {
                $(".wcs-fadeout.wcs-top248").removeClass("wcs-top248").addClass("wcs-top106");
            } else {
                $wcsFadeoutTop106.removeClass("wcs-top133");
            }
        }
    });
    /****/
    //RB-9745
    window.initTopMessage = function() {
        var $body = $('body');
        var $messageDiv = $('.wcs-top-message-container');
        var $closeLink = $messageDiv.find('.wcs-message-close-link');
        if ($messageDiv.length) {
            if (!getCookie('rayban_cookies_policy')) {
                $messageDiv.removeClass('wcs-hide');
                $body.addClass('wcs-body-with-message');
            }
            $closeLink.off('click').on('click', function(evt) {
                evt.preventDefault();
                $messageDiv.addClass('wcs-hide');
                $body.removeClass('wcs-body-with-message');
                $.cookie('rayban_cookies_policy','True',{expires:2657200, path:'/'});
            });
        }
        $closeLink.off('click').on('click', function(evt) {
            evt.preventDefault();
            $messageDiv.addClass('wcs-hide');
            $body.removeClass('wcs-body-with-message');
            $.cookie('rayban_cookies_policy','True',{expires:2657200, path:'/'});
        });
    };
    initTopMessage();

    window.wcs_paypal_overlay = function() {
        if ($("#ExpPaypal").val() === "true") {
            var $checkoutWithPaypal = $(".wcs-checkout-with-paypal");
            var $paypalError = $(".wcs-paypal-error");
            var $paypalExpressCheckout = $("#wcs-paypal-express-checkout");
            var $agreeConcent_popup = $("#agreeConcent_popup");

            $checkoutWithPaypal.off("click").on("click", function () {
                $paypalError.css("display", "none");
                $agreeConcent_popup.removeAttr("checked");
                $(".wcs-label-check.wcs-terms-and-conditions").removeClass("wcs-c-on");
            });

            $paypalExpressCheckout.find(".wcs-checkbox").on("click", function() {
                $paypalError.css("display", "none");
            });

            $paypalExpressCheckout.find(".proceed-to-paypal").on('click',function(e) {
                var href_url = $checkoutWithPaypal.attr("href-url");
                var checked = $agreeConcent_popup.is(':checked');
                if (checked) {
                    $(".proceed-to-paypal").attr("href", href_url);
                } else {
                    $paypalError.css("display", "block");
                }
            });
        }
    };
}
/* ------------------------------------------------------------------------
    HEADER FUNCTION ENDS
---------------------------------------------------------------------------*/
